document.querySelectorAll('.ritual-shop[data-catalog]').forEach(root => {
  if (root.dataset.physicalCatalogUrl) {
    const destination = new URL(location.href);
    destination.pathname = new URL(root.dataset.physicalCatalogUrl, location.origin).pathname;
    destination.searchParams.set('view', 'shop');
    destination.searchParams.delete('section_id');
    const link = root.querySelector('[data-physical-catalog-link]');
    if (link) link.href = destination.href;
    location.replace(destination.href);
    return;
  }
  const synchronize = () => {
    const selected = root.querySelector('.catalog-categories [aria-current="page"]');
    if (selected && innerWidth < 990) {
      const nav = selected.parentElement;
      const navBox = nav.getBoundingClientRect();
      const selectedBox = selected.getBoundingClientRect();
      if (selectedBox.left < navBox.left) nav.scrollLeft -= navBox.left - selectedBox.left;
      else if (selectedBox.right > navBox.right) nav.scrollLeft += selectedBox.right - navBox.right;
    }
    root.querySelectorAll('.ritual-shop__pagination a').forEach(link => {
      const url = new URL(link.href);
      url.searchParams.set('view', 'shop');
      link.href = url.href;
    });
  };
  new MutationObserver(synchronize).observe(root.querySelector('[data-catalog-content]').parentElement, { childList: true });
  synchronize();
});

